<div class="popup-container" *ngIf="inRecent" >  
  <div style="float: right;" *ngIf="!inRecent">
    <button class="close-btn" (click)="closePopup()">×</button>
  </div>
    <div class="popup-header" >
      <img src="../../assets//images/Frame 1000003395.png" width="52" height="52" style="margin-bottom: 10px;"/>
      <span style="color: black; font-size: 16px; font-weight:bold;margin-bottom: 10px;">Subscribe our Newsletter!</span>
      <span style="color: #7C7C7C;font-size: 12px;font-weight: bold; ">Be the first one to get the latest news and updates by subscribing to our newsletter now</span>

      <!-- <span *ngIf="inRecent" style="color: black; font-size: 21px; font-weight:bold;margin-bottom: 10px;">Subscribe our Newsletter!</span>
      <span  *ngIf="inRecent" style="color: #7C7C7C;font-size: 13px;font-weight: bold; ">Be the first one to get the latest news and updates by subscribing to our newsletter now</span> -->


    </div>
    <div class="popup-body">
      <input type="email" [(ngModel)]="email"  class="form-control custom-input" style="border: none; border-bottom: 1px solid #DFE4EB; outline: none; padding: 5px; font-size: 16px;text-align: center;">
      <button class="subscribe-btn" (click)="subscribe()" >Subscribe</button>
    </div>
  </div>
  

<!-- Pop-UP -->
  <div *ngIf="!inRecent" style="background: white;
  width: 480px; 
  padding: 15px 24px 15px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 8%;
  right: 30%;
  z-index: 1000;
  cursor: grab;" cdkDrag cdkDragHandle >  
    <div style="float: right;">
      <button class="close-btn" (click)="closePopup()">×</button>
    </div>
      <div class="popup-header" >
        <img src="../../assets//images/Frame 1000003395.png" width="52" height="52" style="margin-bottom: 10px;"/>
        <!-- <span style="color: black; font-size: 16px; font-weight:bold;margin-bottom: 10px;">Subscribe our Newsletter!</span>
        <span style="color: #7C7C7C;font-size: 12px;font-weight: bold; ">Be the first one to get the latest news and updates by subscribing to our newsletter now</span>
   -->
        <span  style="color: black; font-size: 21px; font-weight:bold;margin-bottom: 10px;">Subscribe our Newsletter!</span>
        <span  style="color: #7C7C7C;font-size: 13px;font-weight: bold; ">Be the first one to get the latest news and updates by subscribing to our newsletter now</span>
  
  
      </div>
      <div class="popup-body">
        <input type="email" [(ngModel)]="email"  class="form-control custom-input" style="border: none; border-bottom: 1px solid #DFE4EB; outline: none; padding: 5px; font-size: 16px;text-align: center;">
        <button class="subscribe-btn" (click)="subscribe()" >Subscribe</button>
      </div>
    </div>
    